import { adaptFooterContent } from './footer-content/adaptFooterContent';
import { adaptGalleryCarousel } from './gallery-carousel/adaptGalleryCarousel';
import { adaptGalleryGrid } from './gallery-grid/adaptGalleryGrid';
import { adaptMediaComponent } from './media/adaptMediaComponent';
import { adaptTextCTA } from './text-cta/adatTextCTA';

export const gecoComponentRouterSelector = (field, language) => {
  const typeArray = field.path.split('_');
  typeArray.pop();
  const type = typeArray.join('_');

  if (!type) return null;

  switch (type) {
    case 'media':
      return adaptMediaComponent(field, language);
    case 'text_cta':
      return adaptTextCTA(field, language);
    case 'galleryGrid':
      return adaptGalleryGrid(field, language);
    case 'galleryCarousel':
      return adaptGalleryCarousel(field, language);
    case 'FooterContent':
      return adaptFooterContent(field, language);
    default:
      return null;
  }
};

export const getGecoComponentsList = (fields, language) => {
  return fields.map((field) => gecoComponentRouterSelector(field, language));
};
